module.exports = __webpack_public_path__ + "static/media/download.d0e7210c.png";